import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  PageWrapper, Section, SectionWide,
  HeroWrapper, HeroDecor, HeroMandala, HeroContent, HeroEyebrow,
  HeroHeading, HeroSubtitle, HeroCTARow,
  BtnPrimary, BtnGhost, BtnSaffron, BtnOutline, BtnSmall,
  SectionEyebrow, SectionHeading, SectionSubtext,
  TabRow, Tab,
  CardGrid, InfoCard, CardIcon, CardTitle, CardText, CardTag,
  ChatSection, ChatHeader, ChatAvatar, ChatHeaderInfo, ChatBody,
  BotBubble, BotMsg, UserBubble, UserMsg, TypingIndicator,
  OptionsRow, OptionChip, ChatInput, ChatTextInput, ChatSendBtn,
  ProgressBar, ProgressFill,
  DashboardWrapper, DashboardHeader, DashUserInfo, DashBadge,
  DashBody, DashGrid, StatCard, StatLabel, StatValue, StatUnit,
  MealPlanGrid, MealCard, MealCardTime, MealCardBody, MealName,
  MealMeta, NutrientRow, NutrientPill,
  RecipeCard, RecipeImage, RecipeBadge, RecipeBody, RecipeTitle, RecipeMeta,
  ConsultBanner, ConsultHeading, ConsultText, ConsultBtnRow, WABtn,
  WaterTracker, WaterGlasses, WaterGlass,
  FoodListGrid, FoodList, FoodListTitle, FoodItem,
  HighlightStrip, StripStat, OmDivider,
  // New
  FormCard, FormGrid, FormGroup, FormLabel, FormInput, FormSelect,
  CheckboxGrid, CheckboxItem,
  ModalOverlay, ModalBox, ModalClose,
  TrackerGrid, TrackerCard, WeightChart, WeightBar,
  ConditionGrid, ConditionCard, ConditionIcon, ConditionName, ConditionTag,
  AIPlanCard, AIPlanHeader, AIPlanBody, MacroRow, MacroCell, LoadingSpinner,
  YogaRecoGrid, YogaRecoCard, YogaRecoImg, YogaRecoBody, YogaRecoTitle, YogaRecoMeta,
  AdminLayout, AdminSidebar, AdminSidebarItem, AdminContent, AdminTable, Badge,
  AnalyticsGrid, AnalyticsCard,
  LeadBanner, PremiumBadge,
  FreeChatWrapper, ChatModeToggle, ChatModeBtn, ChatQuickActions, QuickChip,
  BottomNav, BottomNavItem, MobileBottomPad,
  DietGlobalStyle,
} from "./Dietplanner.styles";

// ─── Constants & Data ─────────────────────────────────────────────────────────

const CLAUDE_MODEL = "claude-sonnet-4-6";

const QUESTIONS = [
  { id: "stage", text: "Namaste 🙏 Welcome to Yoga Shastra's Nutrition Sanctuary. I'm Priya, your personal wellness guide. To begin, may I know — where are you on your journey right now?", options: ["Trying to Conceive", "Pregnant", "Postpartum / Breastfeeding", "General Wellness"] },
  { id: "trimester", text: "That's beautiful. Which trimester are you in?", options: ["First Trimester (0–12 weeks)", "Second Trimester (13–26 weeks)", "Third Trimester (27–40 weeks)"], condition: (r) => r.stage === "Pregnant" },
  { id: "age",        text: "And how old are you? (Type your age)", type: "text", placeholder: "e.g. 28" },
  { id: "diet",       text: "What is your dietary preference?", options: ["Vegetarian", "Vegan", "Eggetarian", "Non-Vegetarian"] },
  { id: "conditions", text: "Do you have any of these health conditions? (Choose all that apply)", options: ["PCOS / PCOD", "Thyroid", "Gestational Diabetes", "Hypertension", "Anaemia", "None"], multi: true },
  { id: "allergies",  text: "Any food allergies or intolerances I should know about?", options: ["Dairy", "Gluten", "Nuts", "Soy", "Eggs", "None"], multi: true },
  { id: "energy",     text: "How would you describe your current energy levels?", options: ["Always Tired 😔", "Moderate ⚡", "Good 😊", "Very Energetic 🌟"] },
  { id: "digestion",  text: "Any digestion concerns lately?", options: ["Nausea / Morning Sickness", "Constipation", "Bloating", "Acidity", "All Good ✓"], multi: true },
  { id: "water",      text: "How much water do you drink in a day?", options: ["Less than 1 litre", "1–2 litres", "2–3 litres", "More than 3 litres"] },
  { id: "activity",   text: "What is your current activity level?", options: ["Bed Rest / Low Activity", "Light Walks", "Yoga & Gentle Exercise", "Moderate Exercise"] },
  { id: "goal",       text: "What is your primary wellness goal right now?", options: ["Healthy Pregnancy", "Baby's Development", "Lactation Support", "Hormone Balance", "Energy & Recovery", "Fertility Support"] },
];

const MEAL_PLANS = {
  "Pregnant": {
    "First Trimester (0–12 weeks)": [
      { time: "Early Morning", name: "Soaked Almonds + Warm Lemon Water", nutrients: ["Iron", "Vit C"], kcal: "80 kcal", emoji: "🌅" },
      { time: "Breakfast",     name: "Moong Dal Cheela with Mint Chutney", nutrients: ["Protein", "Folate"], kcal: "220 kcal", emoji: "🥞" },
      { time: "Mid Morning",   name: "Banana + A Glass of Milk", nutrients: ["Calcium", "K"], kcal: "180 kcal", emoji: "🍌" },
      { time: "Lunch",         name: "Brown Rice + Dal + Sabzi + Curd", nutrients: ["Carbs", "Probiotics"], kcal: "420 kcal", emoji: "🍛" },
      { time: "Evening Snack", name: "Roasted Makhana + Coconut Water", nutrients: ["Magnesium"], kcal: "120 kcal", emoji: "🥥" },
      { time: "Dinner",        name: "Khichdi with Ghee + Steamed Vegetables", nutrients: ["Easy Digest"], kcal: "350 kcal", emoji: "🫕" },
    ],
    "Second Trimester (13–26 weeks)": [
      { time: "Early Morning", name: "Soaked Figs + Warm Turmeric Milk", nutrients: ["Iron", "Calcium"], kcal: "120 kcal", emoji: "🌅" },
      { time: "Breakfast",     name: "Dalia Upma with Vegetables + Boiled Egg", nutrients: ["Protein", "Fibre"], kcal: "280 kcal", emoji: "🥣" },
      { time: "Mid Morning",   name: "Pomegranate + Handful of Walnuts", nutrients: ["Folate", "Omega-3"], kcal: "200 kcal", emoji: "🍓" },
      { time: "Lunch",         name: "Roti + Palak Paneer + Raita + Salad", nutrients: ["Iron", "Calcium", "Protein"], kcal: "480 kcal", emoji: "🍛" },
      { time: "Evening Snack", name: "Sprouts Chaat + Buttermilk", nutrients: ["Zinc", "Probiotics"], kcal: "150 kcal", emoji: "🥗" },
      { time: "Dinner",        name: "Vegetable Soup + Multigrain Roti + Dal", nutrients: ["Fibre", "Iron"], kcal: "400 kcal", emoji: "🍜" },
    ],
    "Third Trimester (27–40 weeks)": [
      { time: "Early Morning", name: "Dates + Warm Milk + Soaked Almonds", nutrients: ["Iron", "Calcium", "Energy"], kcal: "200 kcal", emoji: "🌅" },
      { time: "Breakfast",     name: "Oats Porridge with Banana & Honey", nutrients: ["Fibre", "Potassium"], kcal: "320 kcal", emoji: "🥣" },
      { time: "Mid Morning",   name: "Coconut Water + Seasonal Fruit", nutrients: ["Electrolytes"], kcal: "120 kcal", emoji: "🥥" },
      { time: "Lunch",         name: "Brown Rice + Drumstick Dal + Stir-fried Greens + Curd", nutrients: ["Iron", "Calcium", "Protein"], kcal: "520 kcal", emoji: "🍛" },
      { time: "Evening Snack", name: "Makhana Kheer or Dry Fruits Mix", nutrients: ["Calcium", "Good Fats"], kcal: "200 kcal", emoji: "🍪" },
      { time: "Dinner",        name: "Light Khichdi + Ghee + Steamed Vegetables + Haldi Milk", nutrients: ["Easy Digest", "Anti-Inflam"], kcal: "380 kcal", emoji: "🫕" },
    ],
  },
  "Postpartum / Breastfeeding": {
    default: [
      { time: "Early Morning", name: "Methi Ladoo + Warm Milk",                    nutrients: ["Lactation"],         kcal: "200 kcal", emoji: "🍪" },
      { time: "Breakfast",     name: "Oats Porridge with Dates & Dry Fruits",       nutrients: ["Iron", "Fibre"],      kcal: "280 kcal", emoji: "🥣" },
      { time: "Lunch",         name: "Dalia Khichdi + Ajwain Kadha + Sabzi",        nutrients: ["Digestion"],          kcal: "400 kcal", emoji: "🍲" },
      { time: "Evening Snack", name: "Gondh Ladoo + Herbal Tea",                    nutrients: ["Recovery"],           kcal: "180 kcal", emoji: "🫖" },
      { time: "Dinner",        name: "Moong Dal Soup + Roti + Ghee",                nutrients: ["Protein", "Good Fats"],kcal: "380 kcal", emoji: "🍜" },
    ],
  },
  "Trying to Conceive": {
    default: [
      { time: "Morning",       name: "Warm Turmeric Milk + Soaked Walnuts",         nutrients: ["Hormone Balance"],    kcal: "160 kcal", emoji: "🥛" },
      { time: "Breakfast",     name: "Avocado Toast + Poached Egg",                 nutrients: ["Folate", "Protein"],  kcal: "300 kcal", emoji: "🥑" },
      { time: "Lunch",         name: "Quinoa Salad + Sprouts + Lemon Dressing",     nutrients: ["Zinc", "Antioxidants"],kcal: "380 kcal", emoji: "🥗" },
      { time: "Snack",         name: "Pumpkin Seeds + Seasonal Fruit",              nutrients: ["Zinc", "Vit C"],      kcal: "140 kcal", emoji: "🎃" },
      { time: "Dinner",        name: "Palak Paneer + Multigrain Roti",              nutrients: ["Iron", "Calcium"],    kcal: "400 kcal", emoji: "🫓" },
    ],
  },
  "General Wellness": {
    default: [
      { time: "Early Morning", name: "Warm Lemon Honey Water + Soaked Almonds",     nutrients: ["Antioxidants"],       kcal: "80 kcal",  emoji: "🌅" },
      { time: "Breakfast",     name: "Idli + Sambar + Coconut Chutney",             nutrients: ["Probiotics", "Fibre"],kcal: "260 kcal", emoji: "🍚" },
      { time: "Lunch",         name: "Mixed Dal + Roti + Salad + Curd",             nutrients: ["Protein", "Carbs"],   kcal: "450 kcal", emoji: "🍛" },
      { time: "Snack",         name: "Roasted Chana + Green Tea",                   nutrients: ["Protein", "EGCG"],    kcal: "130 kcal", emoji: "🍵" },
      { time: "Dinner",        name: "Vegetable Soup + Brown Rice Khichdi",         nutrients: ["Fibre", "Easy Digest"],kcal: "360 kcal", emoji: "🫕" },
    ],
  },
};

const FOODS_DATA = {
  eat:   [
    { emoji: "🥬", name: "Spinach, Fenugreek, Drumstick Leaves" },
    { emoji: "🥛", name: "Milk, Curd, Paneer, Ghee" },
    { emoji: "🫘", name: "Lentils, Chickpeas, Moong Dal" },
    { emoji: "🌰", name: "Almonds, Walnuts, Pumpkin Seeds" },
    { emoji: "🍌", name: "Banana, Dates, Pomegranate, Kiwi" },
    { emoji: "🥚", name: "Eggs (if non-vegetarian / eggetarian)" },
    { emoji: "🐟", name: "Salmon, Sardines (rich in Omega-3)" },
    { emoji: "🌾", name: "Brown Rice, Millets, Oats, Quinoa" },
  ],
  avoid: [
    { emoji: "🚫", name: "Raw / Undercooked Meat & Eggs" },
    { emoji: "🥤", name: "Sugary Drinks, Packaged Juices" },
    { emoji: "🍟", name: "Deep Fried, Highly Processed Foods" },
    { emoji: "☕", name: "Excess Caffeine (> 200mg/day)" },
    { emoji: "🧀", name: "Unpasteurised Cheese & Milk" },
    { emoji: "🍣", name: "High Mercury Fish (Shark, Swordfish)" },
    { emoji: "🧂", name: "Excess Salt & Sodium-Rich Foods" },
    { emoji: "🍷", name: "Alcohol — strictly avoid" },
  ],
};

const RECIPES = [
  { emoji: "🌿", title: "Satvik Moong Dal Khichdi",        time: "20 min", category: "Prenatal",  difficulty: "Easy",   bg: "#F5E8CC" },
  { emoji: "🍓", title: "Iron-Rich Pregnancy Smoothie",    time: "5 min",  category: "Fertility", difficulty: "Easy",   bg: "#F2DED4" },
  { emoji: "🫚", title: "Methi Thepla with Ghee",           time: "30 min", category: "Postnatal", difficulty: "Medium", bg: "#EDE3D5" },
  { emoji: "🥣", title: "Lactation Oats Porridge",         time: "10 min", category: "Postnatal", difficulty: "Easy",   bg: "#F5E8CC" },
  { emoji: "🌾", title: "Ragi Ladoo with Jaggery",         time: "25 min", category: "Prenatal",  difficulty: "Easy",   bg: "#F2DED4" },
  { emoji: "🥗", title: "Hormone-Balance Salad Bowl",       time: "15 min", category: "Fertility", difficulty: "Easy",   bg: "#EDE3D5" },
  { emoji: "🍵", title: "PCOS Anti-Inflammatory Kadha",    time: "10 min", category: "PCOS",      difficulty: "Easy",   bg: "#F5E8CC" },
  { emoji: "🍛", title: "Diabetic-Friendly Millet Khichdi",time: "20 min", category: "Diabetes",  difficulty: "Easy",   bg: "#F2DED4" },
];

const CORE_SECTIONS = [
  { icon: "🤰", title: "Prenatal Nutrition",   text: "Trimester-wise meal guidance, iron & folate-rich foods, nutrient timing for a healthy pregnancy.",        tags: ["Trimester Plans", "Iron-Rich", "Folate"],   bg: "#F5E8CC" },
  { icon: "🤱", title: "Postnatal Nutrition",  text: "Lactation boosters, C-section recovery meals, energy restoration and immunity support.",                   tags: ["Lactation", "Recovery", "Energy"],          bg: "#F2DED4" },
  { icon: "🌸", title: "Fertility Diet",       text: "PCOS-friendly eating, hormone-balancing foods, and evidence-based fertility nutrition.",                   tags: ["PCOS", "Hormones", "Fertility"],            bg: "#EDE3D5" },
  { icon: "📋", title: "Weekly Meal Plans",    text: "Downloadable, personalized weekly diet charts tailored to your stage and preferences.",                   tags: ["Personalized", "PDF", "Weekly"],            bg: "#F5E8CC" },
  { icon: "👩‍🍳", title: "Healthy Recipes",   text: "100+ Indian satvik recipes — smoothies, snacks, main meals, and lactation specials.",                     tags: ["Indian", "Satvik", "Quick"],                bg: "#EDE3D5" },
  { icon: "👩‍⚕️", title: "Expert Consultation",text: "Book 1-on-1 sessions with certified prenatal nutritionists via video or WhatsApp.",                      tags: ["Video Call", "WhatsApp", "Certified"],      bg: "#F2DED4" },
];

const CONDITIONS = [
  { icon: "🤰", name: "Pregnancy",     tag: "Trimester plans",     id: "pregnancy"   },
  { icon: "🤱", name: "Postpartum",    tag: "Recovery & lactation", id: "postpartum"  },
  { icon: "🌸", name: "Breastfeeding", tag: "Milk supply boost",   id: "breastfeed"  },
  { icon: "💮", name: "Fertility",     tag: "Cycle nutrition",     id: "fertility"   },
  { icon: "🫁", name: "PCOS / PCOD",   tag: "Hormone balance",     id: "pcos"        },
  { icon: "🍬", name: "Diabetes",      tag: "Blood sugar control", id: "diabetes"    },
  { icon: "🦋", name: "Thyroid",       tag: "Iodine & selenium",   id: "thyroid"     },
  { icon: "🫀", name: "Fatty Liver",   tag: "Liver detox diet",    id: "fattyliver"  },
  { icon: "⬇️", name: "Weight Loss",  tag: "Sustainable deficit", id: "weightloss"  },
  { icon: "⬆️", name: "Weight Gain",  tag: "Lean mass building",  id: "weightgain"  },
  { icon: "🩸", name: "Anaemia",       tag: "Iron-rich protocols", id: "anaemia"     },
  { icon: "💆", name: "Stress & Sleep",tag: "Adaptogenic foods",   id: "stress"      },
];

const YOGA_RECOS = [
  { emoji: "🧘", title: "Prenatal Yoga",         meta: "Gentle flows for each trimester",       bg: "#F5E8CC", type: "course" },
  { emoji: "🌬️", title: "Pranayama for Fertility",meta: "Breathwork to balance hormones",       bg: "#F2DED4", type: "course" },
  { emoji: "🪷", title: "Postnatal Recovery",     meta: "Restorative practices post-delivery",  bg: "#EDE3D5", type: "course" },
  { emoji: "🌿", title: "PCOS Yoga Protocol",     meta: "Targeted poses for hormonal balance",  bg: "#F5E8CC", type: "video"  },
  { emoji: "🍃", title: "Stress Relief Series",   meta: "Yoga nidra & deep relaxation",         bg: "#F2DED4", type: "blog"   },
  { emoji: "🔥", title: "Surya Namaskar Guide",   meta: "Weight management through flow yoga",  bg: "#EDE3D5", type: "video"  },
];

const ADMIN_PIN = "1234";

// ─── AI helpers ───────────────────────────────────────────────────────────────

async function callClaude(systemPrompt, userMessage, history = []) {
  const messages = [
    ...history,
    { role: "user", content: userMessage },
  ];
  const res = await fetch("https://api.anthropic.com/v1/messages", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      model: CLAUDE_MODEL,
      max_tokens: 1000,
      system: systemPrompt,
      messages,
    }),
  });
  const data = await res.json();
  return data.content?.map(b => b.text || "").join("") || "I'm having trouble responding right now. Please try again.";
}

function buildProfileContext(profile, responses) {
  return `
User Health Profile:
- Stage: ${responses.stage || profile.stage || "General Wellness"}
- Age: ${responses.age || profile.age || "Not specified"}
- Gender: ${profile.gender || "Female"}
- Height: ${profile.height ? profile.height + " cm" : "Not specified"}
- Weight: ${profile.weight ? profile.weight + " kg" : "Not specified"}
- Activity Level: ${responses.activity || profile.activity || "Not specified"}
- Dietary Preference: ${responses.diet || profile.diet || "Vegetarian"}
- Medical Conditions: ${responses.conditions || profile.conditions?.join(", ") || "None"}
- Allergies: ${responses.allergies || profile.allergies?.join(", ") || "None"}
- Goal: ${responses.goal || profile.goal || "General Wellness"}
- Trimester: ${responses.trimester || "N/A"}
`.trim();
}

const AI_NUTRITIONIST_SYSTEM = (profileCtx) => `You are Priya, a certified prenatal and postnatal nutritionist and Ayurvedic wellness expert at Yoga Shastra. You specialise in Indian nutrition, women's health, and holistic wellness.

${profileCtx}

Guidelines:
- Give warm, compassionate, practical advice rooted in Indian food culture
- Recommend specific Indian foods by name (dal, sabzi, roti, ghee, etc.)
- Always factor in the user's dietary preference and medical conditions
- Keep responses concise but helpful (3-5 sentences unless a meal plan is requested)
- When suggesting meal plans, format them clearly with timings
- Gently remind users to consult their doctor for medical concerns
- Occasionally suggest related yoga practices from Yoga Shastra
- Never give advice that contradicts standard medical guidelines`;

// ─── Sub-components ───────────────────────────────────────────────────────────

function WaterTrackerWidget({ glasses, setGlasses }) {
  return (
    <WaterTracker>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <p style={{ margin: 0, fontSize: 12, color: "#9C7E66", letterSpacing: "0.1em", textTransform: "uppercase", fontWeight: 500 }}>Water Today</p>
          <p style={{ margin: "4px 0 0", fontFamily: "'Cormorant Garamond', serif", fontSize: 28, fontWeight: 500, color: "#2E1A0E" }}>{glasses} <span style={{ fontSize: 14, fontWeight: 400, color: "#9C7E66" }}>/ 8 glasses</span></p>
        </div>
        <span style={{ fontSize: 32 }}>💧</span>
      </div>
      <WaterGlasses>
        {Array.from({ length: 8 }).map((_, i) => (
          <WaterGlass key={i} $filled={i < glasses} onClick={() => setGlasses(i < glasses ? i : i + 1)}>
            {i < glasses ? "💧" : "🫙"}
          </WaterGlass>
        ))}
      </WaterGlasses>
      {glasses >= 8 && <p style={{ margin: 0, fontSize: 13, color: "#16a34a", fontWeight: 500 }}>🎉 Daily water goal achieved!</p>}
    </WaterTracker>
  );
}

function TypingBubble() {
  return (
    <BotBubble>
      <div style={{ width: 28, height: 28, borderRadius: "50%", background: "#C05C00", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, flexShrink: 0 }}>🌸</div>
      <TypingIndicator><span /><span /><span /></TypingIndicator>
    </BotBubble>
  );
}

function MacroDisplay({ calories, protein, carbs, fat, water }) {
  return (
    <MacroRow>
      <MacroCell $bg="#FFF8ED" $color="#C05C00"><strong>{calories}</strong><span>kcal / day</span></MacroCell>
      <MacroCell $bg="#F5EDF0" $color="#9E4C3B"><strong>{protein}g</strong><span>Protein</span></MacroCell>
      <MacroCell $bg="#EDF5F0" $color="#166534"><strong>{carbs}g</strong><span>Carbs</span></MacroCell>
      <MacroCell $bg="#EDF1F5" $color="#1e40af"><strong>{fat}g</strong><span>Healthy Fat</span></MacroCell>
    </MacroRow>
  );
}

function AdherenceRing({ pct }) {
  const r = 42, c = 2 * Math.PI * r;
  const offset = c - (pct / 100) * c;
  return (
    <div style={{ position: "relative", width: 110, height: 110, flexShrink: 0 }}>
      <svg width="110" height="110" style={{ transform: "rotate(-90deg)" }}>
        <circle cx="55" cy="55" r={r} fill="none" stroke="#F2E8D8" strokeWidth="10" />
        <circle cx="55" cy="55" r={r} fill="none" stroke="#C05C00" strokeWidth="10"
          strokeDasharray={c} strokeDashoffset={offset}
          strokeLinecap="round" style={{ transition: "stroke-dashoffset 0.8s ease" }} />
      </svg>
      <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, fontWeight: 500, color: "#2E1A0E" }}>{pct}%</span>
        <span style={{ fontSize: 10, color: "#9C7E66" }}>adherence</span>
      </div>
    </div>
  );
}

// ─── Main Component ───────────────────────────────────────────────────────────

export default function DietPlanner() {
  // ── Navigation ──
  const [activeSection, setActiveSection]   = useState("home");
  const [adminSub, setAdminSub]             = useState("analytics");

  // ── Onboarding chat ──
  const [messages, setMessages]             = useState([]);
  const [qIndex, setQIndex]                 = useState(0);
  const [responses, setResponses]           = useState({});
  const [inputText, setInputText]           = useState("");
  const [isTyping, setIsTyping]             = useState(false);
  const [selectedChips, setSelectedChips]   = useState([]);
  const [chatDone, setChatDone]             = useState(false);
  const [showDashboard, setShowDashboard]   = useState(false);

  // ── Health profile ──
  const [profile, setProfile] = useState({
    name: "", age: "", gender: "Female", height: "", weight: "",
    activity: "Light Walks", diet: "Vegetarian",
    conditions: [], allergies: [], goal: "General Wellness", stage: "General Wellness",
  });

  // ── AI Diet generator ──
  const [selectedCondition, setSelectedCondition] = useState(null);
  const [aiPlan, setAiPlan]                       = useState(null);
  const [aiLoading, setAiLoading]                 = useState(false);

  // ── Free AI chatbot ──
  const [freeMessages, setFreeMessages]     = useState([]);
  const [freeInput, setFreeInput]           = useState("");
  const [freeTyping, setFreeTyping]         = useState(false);
  const [chatMode, setChatMode]             = useState("guide"); // "guide" | "free"

  // ── Progress ──
  const [glasses, setGlasses]               = useState(3);
  const [weightLog, setWeightLog]           = useState([
    { date: "Jun 1", val: 68 }, { date: "Jun 5", val: 67.4 }, { date: "Jun 10", val: 67 },
    { date: "Jun 15", val: 66.5 }, { date: "Jun 20", val: 66.1 },
  ]);
  const [newWeight, setNewWeight]           = useState("");
  const [mealAdherence]                     = useState(72);
  const [mealLog, setMealLog]               = useState({ breakfast: false, lunch: false, snack: false, dinner: false });

  // ── UI ──
  const [activeTab, setActiveTab]           = useState("Prenatal Nutrition");
  const [modal, setModal]                   = useState(null); // 'pdf' | 'booking' | 'premium'
  const [adminUnlocked, setAdminUnlocked]   = useState(false);
  const [adminPin, setAdminPin]             = useState("");
  const [planTab, setPlanTab]               = useState("meal"); // 'meal' | 'yoga'

  const chatEndRef   = useRef(null);
  const freeChatEnd  = useRef(null);

  const scrollToBottom = () => chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  const scrollFreeEnd  = () => freeChatEnd.current?.scrollIntoView({ behavior: "smooth" });

  useEffect(() => { scrollToBottom(); }, [messages, isTyping]);
  useEffect(() => { scrollFreeEnd();  }, [freeMessages, freeTyping]);

  const getFilteredQuestions = useCallback(() =>
    QUESTIONS.filter(q => !q.condition || q.condition(responses)), [responses]);

  useEffect(() => {
    if (activeSection === "chat" && messages.length === 0) {
      setIsTyping(true);
      setTimeout(() => {
        setIsTyping(false);
        setMessages([{ role: "bot", text: QUESTIONS[0].text, q: QUESTIONS[0] }]);
      }, 900);
    }
  }, [activeSection]);

  // ── Onboarding chat logic ──
  const advanceChat = useCallback((answer, qid) => {
    const newResponses = { ...responses, [qid]: answer };
    setResponses(newResponses);
    const filtered = QUESTIONS.filter(q => !q.condition || q.condition(newResponses));
    const nextIdx = filtered.findIndex(q => q.id === qid) + 1;
    if (nextIdx >= filtered.length) {
      setIsTyping(true);
      setTimeout(() => {
        setIsTyping(false);
        setMessages(m => [...m, { role: "bot", text: `Thank you! 🌸 I've gathered everything I need. Your personalised wellness plan is ready — click below to view it.` }]);
        setTimeout(() => { setShowDashboard(true); setChatDone(true); }, 1600);
      }, 1000);
      return;
    }
    const nextQ = filtered[nextIdx];
    setIsTyping(true);
    setTimeout(() => {
      setIsTyping(false);
      setMessages(m => [...m, { role: "bot", text: nextQ.text, q: nextQ }]);
      setSelectedChips([]);
    }, 1000);
  }, [responses]);

  const handleChipSelect = (chip, q) => {
    if (q.multi) {
      setSelectedChips(prev => prev.includes(chip) ? prev.filter(c => c !== chip) : [...prev, chip]);
    } else {
      setMessages(m => [...m, { role: "user", text: chip }]);
      advanceChat(chip, q.id);
    }
  };

  const handleMultiConfirm = (q) => {
    if (selectedChips.length === 0) return;
    const answer = selectedChips.join(", ");
    setMessages(m => [...m, { role: "user", text: answer }]);
    advanceChat(answer, q.id);
  };

  const handleTextSend = (q) => {
    const val = inputText.trim();
    if (!val) return;
    setMessages(m => [...m, { role: "user", text: val }]);
    setInputText("");
    advanceChat(val, q.id);
  };

  // ── Free AI chatbot ──
  const initFreeChat = useCallback(async () => {
    if (freeMessages.length > 0) return;
    const greeting = `Namaste! 🌸 I'm Priya, your personal nutrition guide. I've read your health profile and I'm here to help with any nutrition questions, meal modifications, or wellness advice. What would you like to know today?`;
    setFreeMessages([{ role: "bot", text: greeting }]);
  }, [freeMessages]);

  useEffect(() => {
    if (activeSection === "chat" && chatDone && chatMode === "free") {
      initFreeChat();
    }
  }, [chatMode, activeSection, chatDone]);

  const sendFreeMessage = useCallback(async (text) => {
    if (!text.trim()) return;
    const userMsg = { role: "user", text };
    const newMsgs = [...freeMessages, userMsg];
    setFreeMessages(newMsgs);
    setFreeInput("");
    setFreeTyping(true);
    try {
      const profileCtx = buildProfileContext(profile, responses);
      const history = freeMessages.map(m => ({ role: m.role === "bot" ? "assistant" : "user", content: m.text }));
      const reply = await callClaude(AI_NUTRITIONIST_SYSTEM(profileCtx), text, history);
      setFreeMessages(m => [...m, { role: "bot", text: reply }]);
    } catch {
      setFreeMessages(m => [...m, { role: "bot", text: "I'm having a moment — please try again shortly 🌸" }]);
    }
    setFreeTyping(false);
  }, [freeMessages, profile, responses]);

  // ── AI Diet Plan generator ──
  const generateAIPlan = useCallback(async (condition) => {
    setAiLoading(true);
    setAiPlan(null);
    setSelectedCondition(condition);
    try {
      const profileCtx = buildProfileContext(profile, responses);
      const prompt = `Based on this user's profile, generate a one-day personalized Indian meal plan for: ${condition.name}.

${profileCtx}

Return ONLY a JSON object (no markdown, no explanation) with this exact structure:
{
  "calories": 2000,
  "protein": 65,
  "carbs": 240,
  "fat": 60,
  "water": 2.5,
  "meals": [
    {"time": "Early Morning", "name": "...", "kcal": "80 kcal", "emoji": "🌅", "nutrients": ["Iron", "Vit C"]},
    ...6 meals total...
  ],
  "tips": ["tip1", "tip2", "tip3"],
  "supplements": ["supplement1", "supplement2"],
  "yogaReco": "Name of a relevant yoga practice"
}`;
      const raw = await callClaude(
        "You are a certified Indian nutritionist. Return ONLY valid JSON, no markdown code blocks.",
        prompt
      );
      const clean = raw.replace(/```json|```/g, "").trim();
      const parsed = JSON.parse(clean);
      setAiPlan(parsed);
    } catch {
      setAiPlan({ error: true });
    }
    setAiLoading(false);
  }, [profile, responses]);

  // ── Helpers ──
  const getMealPlan = () => {
    const stage = responses.stage || "General Wellness";
    const plans = MEAL_PLANS[stage];
    if (!plans) return MEAL_PLANS["General Wellness"].default;
    return plans[responses.trimester] || plans.default || [];
  };

  const progress = (() => {
    const filtered = QUESTIONS.filter(q => !q.condition || q.condition(responses));
    const answered = filtered.filter(q => responses[q.id]).length;
    return Math.round((answered / filtered.length) * 100);
  })();

  const calcCalories = () => {
    const stage = responses.stage || profile.stage;
    if (stage === "Pregnant") return 2400;
    if (stage === "Postpartum / Breastfeeding") return 2600;
    if (stage === "Trying to Conceive") return 2000;
    return 1800;
  };

  // ─── Render Sections ─────────────────────────────────────────────────────────

  const renderHome = () => (
    <>
      <HeroWrapper>
        <HeroDecor /><HeroMandala />
        <HeroContent>
          <HeroEyebrow><span /> Yoga Shastra · Nutrition Sanctuary</HeroEyebrow>
          <HeroHeading>Nourish Your Body,<br /><em>Honour the Journey</em></HeroHeading>
          <HeroSubtitle>Ancient Vedic wisdom meets modern nutrition science — personalised meal plans for pregnancy, postnatal recovery, fertility, and women's wellness.</HeroSubtitle>
          <HeroCTARow>
            <BtnPrimary onClick={() => setActiveSection("profile")}>Build My Health Profile ✨</BtnPrimary>
            <BtnGhost onClick={() => setActiveSection("chat")}>Talk to Priya 🌸</BtnGhost>
          </HeroCTARow>
        </HeroContent>
      </HeroWrapper>

      <HighlightStrip>
        {[["5000+", "Women Guided"], ["100+", "Vedic Recipes"], ["12", "Specialised Plans"], ["4.9★", "Average Rating"]].map(([v, l]) => (
          <StripStat key={l}><strong>{v}</strong><span>{l}</span></StripStat>
        ))}
      </HighlightStrip>

      <Section>
        <SectionEyebrow>What We Offer</SectionEyebrow>
        <SectionHeading>A Complete <em>Wellness Ecosystem</em></SectionHeading>
        <SectionSubtext>Everything you need — from trimester-wise meal plans to AI-powered nutrition guidance, all in one warm, supportive space.</SectionSubtext>
        <CardGrid>
          {CORE_SECTIONS.map((s, i) => (
            <InfoCard key={s.title} $delay={`${i * 0.1}s`}>
              <CardIcon $bg={s.bg}>{s.icon}</CardIcon>
              <CardTitle>{s.title}</CardTitle>
              <CardText>{s.text}</CardText>
              <div>{s.tags.map(t => <CardTag key={t}>{t}</CardTag>)}</div>
            </InfoCard>
          ))}
        </CardGrid>
      </Section>

      <Section style={{ background: "#EDE3D5", borderRadius: 28, maxWidth: "100%", padding: "64px 40px" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <SectionEyebrow>Specialised Plans</SectionEyebrow>
          <SectionHeading>Plans for <em>Every Condition</em></SectionHeading>
          <SectionSubtext>Whether you are managing PCOS, navigating pregnancy, or building fertility — we have a plan designed for you.</SectionSubtext>
          <ConditionGrid>
            {CONDITIONS.slice(0, 6).map((c, i) => (
              <ConditionCard key={c.id} $delay={`${i * 0.08}s`} onClick={() => { setSelectedCondition(c); setActiveSection("plans"); }}>
                <ConditionIcon>{c.icon}</ConditionIcon>
                <ConditionName>{c.name}</ConditionName>
                <ConditionTag>{c.tag}</ConditionTag>
              </ConditionCard>
            ))}
          </ConditionGrid>
          <div style={{ textAlign: "center", marginTop: 28 }}>
            <BtnSaffron onClick={() => setActiveSection("plans")}>View All 12 Plans →</BtnSaffron>
          </div>
        </div>
      </Section>

      <LeadBanner style={{ maxWidth: 900, margin: "0 auto 40px" }}>
        <PremiumBadge>⭐ Premium Feature</PremiumBadge>
        <SectionHeading style={{ margin: "0 0 12px" }}>Download Your <em>Personalised PDF Plan</em></SectionHeading>
        <p style={{ color: "#9C7E66", marginBottom: 28, fontSize: 15 }}>Get a beautiful, printable 7-day meal plan crafted for your unique health profile — completely free.</p>
        <HeroCTARow style={{ justifyContent: "center" }}>
          <BtnSaffron onClick={() => setModal("pdf")}>📄 Download Free PDF Plan</BtnSaffron>
          <BtnOutline onClick={() => setModal("booking")}>📅 Book Consultation</BtnOutline>
        </HeroCTARow>
      </LeadBanner>
    </>
  );

  // ── Health Profile ──
  const renderProfile = () => {
    const multiCheck = (field, val) => {
      setProfile(p => ({
        ...p,
        [field]: p[field].includes(val) ? p[field].filter(v => v !== val) : [...p[field], val],
      }));
    };
    return (
      <Section>
        <SectionEyebrow>Your Health Profile</SectionEyebrow>
        <SectionHeading>Tell Us <em>About You</em></SectionHeading>
        <SectionSubtext>The more we know, the better your personalised plan will be. All data stays private on your device.</SectionSubtext>

        <FormCard>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 500, color: "#2E1A0E", marginBottom: 24 }}>Basic Information</p>
          <FormGrid $cols={2}>
            <FormGroup>
              <FormLabel>Your Name</FormLabel>
              <FormInput placeholder="e.g. Priya Sharma" value={profile.name} onChange={e => setProfile(p => ({ ...p, name: e.target.value }))} />
            </FormGroup>
            <FormGroup>
              <FormLabel>Age</FormLabel>
              <FormInput type="number" placeholder="e.g. 28" value={profile.age} onChange={e => setProfile(p => ({ ...p, age: e.target.value }))} />
            </FormGroup>
            <FormGroup>
              <FormLabel>Gender</FormLabel>
              <FormSelect value={profile.gender} onChange={e => setProfile(p => ({ ...p, gender: e.target.value }))}>
                <option>Female</option><option>Male</option><option>Other</option>
              </FormSelect>
            </FormGroup>
            <FormGroup>
              <FormLabel>Height (cm)</FormLabel>
              <FormInput type="number" placeholder="e.g. 162" value={profile.height} onChange={e => setProfile(p => ({ ...p, height: e.target.value }))} />
            </FormGroup>
            <FormGroup>
              <FormLabel>Weight (kg)</FormLabel>
              <FormInput type="number" placeholder="e.g. 58" value={profile.weight} onChange={e => setProfile(p => ({ ...p, weight: e.target.value }))} />
            </FormGroup>
            <FormGroup>
              <FormLabel>Activity Level</FormLabel>
              <FormSelect value={profile.activity} onChange={e => setProfile(p => ({ ...p, activity: e.target.value }))}>
                {["Bed Rest / Low Activity","Light Walks","Yoga & Gentle Exercise","Moderate Exercise","Active / High Intensity"].map(o => <option key={o}>{o}</option>)}
              </FormSelect>
            </FormGroup>
          </FormGrid>

          <div style={{ height: 1, background: "rgba(192,92,0,0.1)", margin: "28px 0" }} />
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 500, color: "#2E1A0E", marginBottom: 20 }}>Current Life Stage</p>
          <FormGroup style={{ marginBottom: 24 }}>
            <FormLabel>Stage</FormLabel>
            <FormSelect value={profile.stage} onChange={e => setProfile(p => ({ ...p, stage: e.target.value }))}>
              {["Trying to Conceive","Pregnant","Postpartum / Breastfeeding","General Wellness"].map(o => <option key={o}>{o}</option>)}
            </FormSelect>
          </FormGroup>
          <FormGrid $cols={2}>
            <FormGroup>
              <FormLabel>Dietary Preference</FormLabel>
              <FormSelect value={profile.diet} onChange={e => setProfile(p => ({ ...p, diet: e.target.value }))}>
                {["Vegetarian","Vegan","Eggetarian","Non-Vegetarian"].map(o => <option key={o}>{o}</option>)}
              </FormSelect>
            </FormGroup>
            <FormGroup>
              <FormLabel>Primary Goal</FormLabel>
              <FormSelect value={profile.goal} onChange={e => setProfile(p => ({ ...p, goal: e.target.value }))}>
                {["Healthy Pregnancy","Baby's Development","Lactation Support","Hormone Balance","Energy & Recovery","Fertility Support","Weight Loss","Weight Gain","General Wellness"].map(o => <option key={o}>{o}</option>)}
              </FormSelect>
            </FormGroup>
          </FormGrid>

          <div style={{ height: 1, background: "rgba(192,92,0,0.1)", margin: "28px 0" }} />
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 500, color: "#2E1A0E", marginBottom: 16 }}>Medical Conditions</p>
          <CheckboxGrid>
            {["PCOS / PCOD","Thyroid","Gestational Diabetes","Hypertension","Anaemia","Fatty Liver","Diabetes (Type 2)","None"].map(c => (
              <CheckboxItem key={c} $checked={profile.conditions.includes(c)}>
                <input type="checkbox" checked={profile.conditions.includes(c)} onChange={() => multiCheck("conditions", c)} />
                {c}
              </CheckboxItem>
            ))}
          </CheckboxGrid>

          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 500, color: "#2E1A0E", margin: "28px 0 16px" }}>Food Allergies</p>
          <CheckboxGrid>
            {["Dairy","Gluten","Nuts","Soy","Eggs","Shellfish","None"].map(c => (
              <CheckboxItem key={c} $checked={profile.allergies.includes(c)}>
                <input type="checkbox" checked={profile.allergies.includes(c)} onChange={() => multiCheck("allergies", c)} />
                {c}
              </CheckboxItem>
            ))}
          </CheckboxGrid>

          <div style={{ marginTop: 36, display: "flex", gap: 14, flexWrap: "wrap" }}>
            <BtnSaffron onClick={() => { setActiveSection("plans"); }}>
              🎯 Generate My AI Diet Plan
            </BtnSaffron>
            <BtnOutline onClick={() => setActiveSection("dashboard")}>
              View Dashboard →
            </BtnOutline>
          </div>
        </FormCard>
      </Section>
    );
  };

  // ── Chat Section ──
  const renderChat = () => (
    <Section>
      <SectionEyebrow>AI Nutrition Guide</SectionEyebrow>
      <SectionHeading>Chat with <em>Priya</em></SectionHeading>
      <SectionSubtext>Your personalised AI nutritionist — profile-aware, context-sensitive, always here.</SectionSubtext>

      {chatDone && (
        <ChatModeToggle>
          <ChatModeBtn $active={chatMode === "guide"} onClick={() => setChatMode("guide")}>📋 Onboarding</ChatModeBtn>
          <ChatModeBtn $active={chatMode === "free"}  onClick={() => { setChatMode("free"); initFreeChat(); }}>💬 Ask Priya Anything</ChatModeBtn>
        </ChatModeToggle>
      )}

      {chatMode === "guide" ? (
        <>
          <ChatSection>
            <ChatHeader>
              <ChatAvatar>🌸</ChatAvatar>
              <ChatHeaderInfo>
                <h4>Priya — Nutrition Guide</h4>
                <p>Certified Prenatal &amp; Postnatal Nutritionist</p>
              </ChatHeaderInfo>
              {chatDone && <BtnSaffron onClick={() => setActiveSection("dashboard")} style={{ marginLeft: "auto", padding: "8px 20px", fontSize: 13 }}>View My Plan →</BtnSaffron>}
            </ChatHeader>
            <ProgressBar><ProgressFill $pct={`${progress}%`} /></ProgressBar>
            <ChatBody>
              {messages.map((msg, i) => (
                msg.role === "bot" ? (
                  <div key={i}>
                    <BotBubble>
                      <div style={{ width: 28, height: 28, borderRadius: "50%", background: "#C05C00", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, flexShrink: 0 }}>🌸</div>
                      <BotMsg>{msg.text}</BotMsg>
                    </BotBubble>
                    {msg.q?.options && !chatDone && i === messages.length - 1 && (
                      <div style={{ marginLeft: 38, marginTop: 10 }}>
                        <OptionsRow>
                          {msg.q.options.map(opt => (
                            <OptionChip key={opt} $selected={selectedChips.includes(opt)} onClick={() => handleChipSelect(opt, msg.q)}>{opt}</OptionChip>
                          ))}
                        </OptionsRow>
                        {msg.q.multi && selectedChips.length > 0 && (
                          <BtnSaffron onClick={() => handleMultiConfirm(msg.q)} style={{ marginTop: 10, padding: "10px 20px", fontSize: 13 }}>Confirm →</BtnSaffron>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <UserBubble key={i}><UserMsg>{msg.text}</UserMsg></UserBubble>
                )
              ))}
              {isTyping && <TypingBubble />}
              <div ref={chatEndRef} />
            </ChatBody>
            {!chatDone && messages.length > 0 && messages[messages.length - 1]?.q?.type === "text" && (
              <ChatInput>
                <ChatTextInput
                  value={inputText}
                  onChange={e => setInputText(e.target.value)}
                  placeholder={messages[messages.length - 1]?.q?.placeholder || "Type your answer…"}
                  onKeyDown={e => e.key === "Enter" && handleTextSend(messages[messages.length - 1]?.q)}
                />
                <ChatSendBtn onClick={() => handleTextSend(messages[messages.length - 1]?.q)}>→</ChatSendBtn>
              </ChatInput>
            )}
          </ChatSection>
          {showDashboard && (
            <div style={{ marginTop: 28, textAlign: "center" }}>
              <BtnSaffron onClick={() => setActiveSection("dashboard")}>🎉 View My Personalised Nutrition Dashboard →</BtnSaffron>
            </div>
          )}
        </>
      ) : (
        // Free AI chatbot
        <FreeChatWrapper>
          <ChatSection>
            <ChatHeader>
              <ChatAvatar>🌸</ChatAvatar>
              <ChatHeaderInfo>
                <h4>Ask Priya Anything</h4>
                <p>AI-powered · reads your profile · saves conversation</p>
              </ChatHeaderInfo>
            </ChatHeader>
            <ChatBody>
              {freeMessages.map((msg, i) => (
                msg.role === "bot" ? (
                  <BotBubble key={i}>
                    <div style={{ width: 28, height: 28, borderRadius: "50%", background: "#C05C00", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, flexShrink: 0 }}>🌸</div>
                    <BotMsg>{msg.text}</BotMsg>
                  </BotBubble>
                ) : (
                  <UserBubble key={i}><UserMsg>{msg.text}</UserMsg></UserBubble>
                )
              ))}
              {freeTyping && <TypingBubble />}
              <div ref={freeChatEnd} />
            </ChatBody>
            <ChatQuickActions>
              {["What should I eat for breakfast?","How much protein do I need?","Foods to boost milk supply","PCOS-friendly snacks","Foods to avoid today"].map(q => (
                <QuickChip key={q} onClick={() => sendFreeMessage(q)}>{q}</QuickChip>
              ))}
            </ChatQuickActions>
            <ChatInput>
              <ChatTextInput
                value={freeInput}
                onChange={e => setFreeInput(e.target.value)}
                placeholder="Ask about nutrition, meal plans, foods…"
                onKeyDown={e => e.key === "Enter" && !freeTyping && sendFreeMessage(freeInput)}
              />
              <ChatSendBtn disabled={freeTyping} onClick={() => sendFreeMessage(freeInput)}>→</ChatSendBtn>
            </ChatInput>
          </ChatSection>
        </FreeChatWrapper>
      )}
    </Section>
  );

  // ── Dashboard ──
  const renderDashboard = () => {
    const meals = getMealPlan();
    const stage = responses.stage || profile.stage || "—";
    const diet  = responses.diet  || profile.diet  || "Vegetarian";
    return (
      <Section>
        <DashboardWrapper>
          <DashboardHeader>
            <DashUserInfo>
              <h3>Your Wellness Dashboard 🌸</h3>
              <p>Personalised for {profile.name || "you"} · Updated today</p>
            </DashUserInfo>
            <DashBadge>🌿 {stage}</DashBadge>
          </DashboardHeader>
          <DashBody>
            <DashGrid>
              <StatCard $bg="#F5E8CC"><StatLabel>Stage</StatLabel><StatValue $color="#C05C00" style={{ fontSize: 18 }}>{stage}</StatValue></StatCard>
              <StatCard><StatLabel>Diet Type</StatLabel><StatValue style={{ fontSize: 18 }}>{diet}</StatValue></StatCard>
              <StatCard $bg="#F2DED4"><StatLabel>Daily Target</StatLabel><StatValue $color="#9E4C3B">{calcCalories()}<StatUnit>kcal</StatUnit></StatValue></StatCard>
              <StatCard><StatLabel>Water Goal</StatLabel><StatValue $color="#7A3300">8<StatUnit>glasses</StatUnit></StatValue></StatCard>
            </DashGrid>

            <WaterTrackerWidget glasses={glasses} setGlasses={setGlasses} />

            {/* Meal adherence */}
            <div style={{ marginTop: 24 }}>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 500, color: "#2E1A0E", marginBottom: 14 }}>Today's Meal Check-in</p>
              <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
                <AdherenceRing pct={Object.values(mealLog).filter(Boolean).length * 25} />
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  {Object.keys(mealLog).map(m => (
                    <CheckboxItem key={m} $checked={mealLog[m]} style={{ padding: "8px 14px", marginBottom: 0 }}
                      onClick={() => setMealLog(l => ({ ...l, [m]: !l[m] }))}>
                      <input type="checkbox" readOnly checked={mealLog[m]} />
                      {m.charAt(0).toUpperCase() + m.slice(1)} completed
                    </CheckboxItem>
                  ))}
                </div>
              </div>
            </div>

            <div style={{ marginTop: 28 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, fontWeight: 500, color: "#2E1A0E", margin: 0 }}>Today's Meal Plan</p>
                <BtnSmall onClick={() => setActiveSection("plans")}>+ AI Customize</BtnSmall>
              </div>
              <MealPlanGrid>
                {meals.map((meal, i) => (
                  <MealCard key={i}>
                    <MealCardTime>{meal.time}</MealCardTime>
                    <MealCardBody>
                      <span style={{ fontSize: 28 }}>{meal.emoji}</span>
                      <MealName>{meal.name}</MealName>
                      <MealMeta>{meal.kcal}</MealMeta>
                      <NutrientRow>{meal.nutrients.map(n => <NutrientPill key={n}>{n}</NutrientPill>)}</NutrientRow>
                    </MealCardBody>
                  </MealCard>
                ))}
              </MealPlanGrid>
            </div>

            <div style={{ marginTop: 28 }}>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, fontWeight: 500, color: "#2E1A0E", marginBottom: 16 }}>Foods Guide</p>
              <FoodListGrid>
                <FoodList>
                  <FoodListTitle>✅ Nourishing Foods to Embrace</FoodListTitle>
                  {FOODS_DATA.eat.map(f => <FoodItem key={f.name}><span>{f.emoji}</span> {f.name}</FoodItem>)}
                </FoodList>
                <FoodList $variant="avoid">
                  <FoodListTitle $variant="avoid">⚠️ Foods to Mindfully Avoid</FoodListTitle>
                  {FOODS_DATA.avoid.map(f => <FoodItem key={f.name}><span>{f.emoji}</span> {f.name}</FoodItem>)}
                </FoodList>
              </FoodListGrid>
            </div>

            <div style={{ marginTop: 32, display: "flex", gap: 14, flexWrap: "wrap" }}>
              <BtnSaffron onClick={() => setModal("pdf")}>📄 Download My PDF Plan</BtnSaffron>
              <BtnOutline onClick={() => setActiveSection("consult")}>👩‍⚕️ Book Consultation</BtnOutline>
            </div>
          </DashBody>
        </DashboardWrapper>
      </Section>
    );
  };

  // ── Specialised Plans ──
  const renderPlans = () => (
    <Section>
      <SectionEyebrow>Specialised Nutrition Plans</SectionEyebrow>
      <SectionHeading>AI-Generated Plans for <em>Your Condition</em></SectionHeading>
      <SectionSubtext>Select your health condition and our AI will generate a personalised Indian meal plan — factoring in your profile, dietary preference, and goals.</SectionSubtext>

      <ConditionGrid>
        {CONDITIONS.map((c, i) => (
          <ConditionCard key={c.id} $delay={`${i * 0.06}s`} $active={selectedCondition?.id === c.id}
            onClick={() => generateAIPlan(c)}>
            <ConditionIcon>{c.icon}</ConditionIcon>
            <ConditionName $active={selectedCondition?.id === c.id}>{c.name}</ConditionName>
            <ConditionTag $active={selectedCondition?.id === c.id}>{c.tag}</ConditionTag>
          </ConditionCard>
        ))}
      </ConditionGrid>

      {aiLoading && (
        <div style={{ textAlign: "center", padding: "40px 0" }}>
          <LoadingSpinner />
          <p style={{ color: "#9C7E66", fontSize: 14 }}>Generating your personalised plan…</p>
        </div>
      )}

      {aiPlan && !aiPlan.error && (
        <AIPlanCard style={{ marginTop: 36 }}>
          <AIPlanHeader>
            <div>
              <p style={{ margin: 0, fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase", color: "rgba(249,241,228,0.7)", fontWeight: 500 }}>AI Plan for</p>
              <p style={{ margin: "4px 0 0", fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontWeight: 500, color: "#F9F1E4" }}>{selectedCondition?.name}</p>
            </div>
            <DashBadge>{selectedCondition?.icon} Personalised</DashBadge>
          </AIPlanHeader>
          <AIPlanBody>
            <MacroDisplay calories={aiPlan.calories} protein={aiPlan.protein} carbs={aiPlan.carbs} fat={aiPlan.fat} water={aiPlan.water} />

            <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 500, color: "#2E1A0E", marginBottom: 16 }}>Today's Meal Plan</p>
            <MealPlanGrid>
              {(aiPlan.meals || []).map((meal, i) => (
                <MealCard key={i}>
                  <MealCardTime>{meal.time}</MealCardTime>
                  <MealCardBody>
                    <span style={{ fontSize: 28 }}>{meal.emoji}</span>
                    <MealName>{meal.name}</MealName>
                    <MealMeta>{meal.kcal}</MealMeta>
                    <NutrientRow>{(meal.nutrients || []).map(n => <NutrientPill key={n}>{n}</NutrientPill>)}</NutrientRow>
                  </MealCardBody>
                </MealCard>
              ))}
            </MealPlanGrid>

            {aiPlan.tips?.length > 0 && (
              <div style={{ marginTop: 28, background: "#FFF8ED", borderRadius: 16, padding: 20, border: "1px solid rgba(192,92,0,0.12)" }}>
                <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontWeight: 500, color: "#2E1A0E", margin: "0 0 12px" }}>💡 Nutrition Tips</p>
                {aiPlan.tips.map((t, i) => <p key={i} style={{ fontSize: 14, color: "#4A2E1A", margin: "0 0 6px", lineHeight: 1.6 }}>• {t}</p>)}
              </div>
            )}
            {aiPlan.supplements?.length > 0 && (
              <div style={{ marginTop: 20, background: "#F2DED4", borderRadius: 16, padding: 20, border: "1px solid rgba(192,92,0,0.12)" }}>
                <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontWeight: 500, color: "#2E1A0E", margin: "0 0 12px" }}>💊 Recommended Supplements</p>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {aiPlan.supplements.map(s => <CardTag key={s}>{s}</CardTag>)}
                </div>
              </div>
            )}
            {aiPlan.yogaReco && (
              <div style={{ marginTop: 20, background: "#EDE3D5", borderRadius: 16, padding: 20, border: "1px solid rgba(192,92,0,0.12)", display: "flex", gap: 12, alignItems: "center" }}>
                <span style={{ fontSize: 32 }}>🧘</span>
                <div>
                  <p style={{ margin: "0 0 4px", fontSize: 12, fontWeight: 500, letterSpacing: "0.1em", textTransform: "uppercase", color: "#9C7E66" }}>Recommended Yoga Practice</p>
                  <p style={{ margin: 0, fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontWeight: 500, color: "#2E1A0E" }}>{aiPlan.yogaReco}</p>
                </div>
                <BtnSmall style={{ marginLeft: "auto" }} onClick={() => setActiveSection("yoga")}>View Practice</BtnSmall>
              </div>
            )}

            <div style={{ marginTop: 28, display: "flex", gap: 14, flexWrap: "wrap" }}>
              <BtnSaffron onClick={() => setModal("pdf")}>📄 Download This Plan</BtnSaffron>
              <BtnOutline onClick={() => { setChatMode("free"); setActiveSection("chat"); initFreeChat(); }}>💬 Ask Priya to Modify</BtnOutline>
            </div>
          </AIPlanBody>
        </AIPlanCard>
      )}
      {aiPlan?.error && (
        <div style={{ textAlign: "center", padding: "32px", color: "#9C7E66" }}>
          <p style={{ fontSize: 32, marginBottom: 8 }}>🌸</p>
          <p>Couldn't generate your plan right now. Please try again.</p>
          <BtnOutline onClick={() => generateAIPlan(selectedCondition)} style={{ marginTop: 12 }}>Retry</BtnOutline>
        </div>
      )}
    </Section>
  );

  // ── Progress Tracker ──
  const renderTracker = () => {
    const maxVal = Math.max(...weightLog.map(w => w.val)) + 2;
    const minVal = Math.min(...weightLog.map(w => w.val)) - 2;
    const range = maxVal - minVal;
    return (
      <Section>
        <SectionEyebrow>Progress Tracking</SectionEyebrow>
        <SectionHeading>Your <em>Wellness Journey</em></SectionHeading>
        <SectionSubtext>Track your weight, water intake, and meal adherence — all in one place.</SectionSubtext>

        <TrackerGrid>
          {/* Weight chart */}
          <TrackerCard>
            <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 500, color: "#2E1A0E", margin: "0 0 18px" }}>⚖️ Weight Log</p>
            <WeightChart>
              {weightLog.map((w, i) => (
                <WeightBar key={i} $active={i === weightLog.length - 1}
                  $h={`${((w.val - minVal) / range) * 80 + 15}%`}
                  data-label={`${w.val} kg\n${w.date}`}
                  title={`${w.date}: ${w.val} kg`} />
              ))}
            </WeightChart>
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6 }}>
              {weightLog.map((w, i) => <span key={i} style={{ fontSize: 10, color: "#9C7E66", flex: 1, textAlign: "center" }}>{w.date.replace("Jun ", "")}</span>)}
            </div>
            <div style={{ marginTop: 18, display: "flex", gap: 10 }}>
              <FormInput type="number" placeholder="Log today's weight (kg)" value={newWeight} onChange={e => setNewWeight(e.target.value)} style={{ flex: 1 }} />
              <BtnSaffron style={{ padding: "0 20px", fontSize: 13 }} onClick={() => {
                if (!newWeight) return;
                const today = `Jun ${new Date().getDate()}`;
                setWeightLog(l => [...l.slice(-4), { date: today, val: parseFloat(newWeight) }]);
                setNewWeight("");
              }}>Log</BtnSaffron>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 12, padding: "12px 16px", background: "#F5E8CC", borderRadius: 12 }}>
              <div><p style={{ margin: 0, fontSize: 11, color: "#9C7E66", fontWeight: 500, textTransform: "uppercase" }}>Start</p><p style={{ margin: 0, fontFamily: "'Cormorant Garamond', serif", fontSize: 22, fontWeight: 500 }}>{weightLog[0]?.val} kg</p></div>
              <div style={{ textAlign: "right" }}><p style={{ margin: 0, fontSize: 11, color: "#9C7E66", fontWeight: 500, textTransform: "uppercase" }}>Current</p><p style={{ margin: 0, fontFamily: "'Cormorant Garamond', serif", fontSize: 22, fontWeight: 500, color: "#C05C00" }}>{weightLog[weightLog.length - 1]?.val} kg</p></div>
            </div>
          </TrackerCard>

          {/* Water + adherence */}
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            <TrackerCard>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 500, color: "#2E1A0E", margin: "0 0 16px" }}>💧 Water Intake</p>
              <WaterTrackerWidget glasses={glasses} setGlasses={setGlasses} />
            </TrackerCard>
            <TrackerCard>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 500, color: "#2E1A0E", margin: "0 0 16px" }}>🍽️ Meal Adherence</p>
              <div style={{ display: "flex", alignItems: "center", gap: 20, flexWrap: "wrap" }}>
                <AdherenceRing pct={mealAdherence} />
                <div style={{ flex: 1 }}>
                  <p style={{ fontSize: 14, color: "#4A2E1A", margin: "0 0 8px" }}>You've followed your meal plan <strong>{mealAdherence}%</strong> this week.</p>
                  <p style={{ fontSize: 13, color: "#9C7E66", margin: 0 }}>Log each meal above on the Dashboard to improve your score.</p>
                  <BtnSmall style={{ marginTop: 12 }} onClick={() => setActiveSection("dashboard")}>Log Today's Meals</BtnSmall>
                </div>
              </div>
            </TrackerCard>
          </div>
        </TrackerGrid>
      </Section>
    );
  };

  // ── Yoga Recommendations ──
  const renderYoga = () => (
    <Section>
      <SectionEyebrow>Yoga Shastra Integration</SectionEyebrow>
      <SectionHeading>Yoga Practices for <em>Your Nutrition Plan</em></SectionHeading>
      <SectionSubtext>Nutrition and yoga work best together. Here are practices recommended for your current health profile and goals.</SectionSubtext>

      <TabRow>
        {["All", "Courses", "Videos", "Blogs"].map(t => (
          <Tab key={t} $active={planTab === t.toLowerCase()} onClick={() => setPlanTab(t.toLowerCase())}>{t}</Tab>
        ))}
      </TabRow>

      <YogaRecoGrid>
        {YOGA_RECOS
          .filter(r => planTab === "all" || r.type === planTab.replace("s", ""))
          .map((r, i) => (
          <YogaRecoCard key={r.title} $delay={`${i * 0.1}s`}>
            <YogaRecoImg $bg={r.bg}>{r.emoji}</YogaRecoImg>
            <YogaRecoBody>
              <CardTag>{r.type}</CardTag>
              <YogaRecoTitle style={{ marginTop: 8 }}>{r.title}</YogaRecoTitle>
              <YogaRecoMeta>{r.meta}</YogaRecoMeta>
              <BtnSaffron style={{ width: "100%", padding: "10px", fontSize: 13, borderRadius: 12 }}>
                {r.type === "blog" ? "Read Article →" : r.type === "video" ? "Watch Now →" : "Start Course →"}
              </BtnSaffron>
            </YogaRecoBody>
          </YogaRecoCard>
        ))}
      </YogaRecoGrid>

      {/* Blog recommendations */}
      <div style={{ marginTop: 52 }}>
        <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontWeight: 500, color: "#2E1A0E", marginBottom: 8 }}>📖 Recommended Reading</p>
        <p style={{ fontSize: 14, color: "#9C7E66", marginBottom: 24 }}>Articles from the Yoga Shastra blog, curated for your profile.</p>
        <CardGrid>
          {[
            { icon: "🌿", title: "Ancient Yoga & Nutrition: The Vedic Connection", tag: "Wellness", bg: "#F5E8CC" },
            { icon: "🤰", title: "Foods That Support Every Trimester", tag: "Prenatal", bg: "#F2DED4" },
            { icon: "🌸", title: "PCOS Diet: What the Research Actually Says", tag: "Fertility", bg: "#EDE3D5" },
          ].map((b, i) => (
            <InfoCard key={b.title} $delay={`${i * 0.1}s`}>
              <CardIcon $bg={b.bg}>{b.icon}</CardIcon>
              <CardTitle>{b.title}</CardTitle>
              <CardTag>{b.tag}</CardTag>
              <div style={{ marginTop: 12 }}>
                <BtnOutline style={{ fontSize: 12, padding: "8px 16px" }}>Read on Yoga Shastra →</BtnOutline>
              </div>
            </InfoCard>
          ))}
        </CardGrid>
      </div>
    </Section>
  );

  // ── Nutrition Section ──
  const renderNutrition = () => (
    <Section>
      <SectionEyebrow>Nutrition Knowledge</SectionEyebrow>
      <SectionHeading>Vedic Wisdom Meets <em>Modern Science</em></SectionHeading>
      <SectionSubtext>Explore trimester-wise guidance, postnatal recovery, and fertility nutrition — all rooted in ancient Indian food wisdom.</SectionSubtext>
      <TabRow>
        {["Prenatal Nutrition", "Postnatal", "Fertility", "Foods Guide"].map(t => (
          <Tab key={t} $active={activeTab === t} onClick={() => setActiveTab(t)}>{t}</Tab>
        ))}
      </TabRow>
      {activeTab === "Foods Guide" ? (
        <FoodListGrid>
          <FoodList><FoodListTitle>✅ Best Foods During Pregnancy</FoodListTitle>{FOODS_DATA.eat.map(f => <FoodItem key={f.name}><span>{f.emoji}</span> {f.name}</FoodItem>)}</FoodList>
          <FoodList $variant="avoid"><FoodListTitle $variant="avoid">⚠️ Foods to Avoid</FoodListTitle>{FOODS_DATA.avoid.map(f => <FoodItem key={f.name}><span>{f.emoji}</span> {f.name}</FoodItem>)}</FoodList>
        </FoodListGrid>
      ) : (
        <CardGrid>
          {CORE_SECTIONS.filter(s => {
            if (activeTab === "Prenatal Nutrition") return s.title.includes("Prenatal") || s.title.includes("Meal");
            if (activeTab === "Postnatal") return s.title.includes("Postnatal") || s.title.includes("Recipes");
            if (activeTab === "Fertility") return s.title.includes("Fertility") || s.title.includes("Consult");
            return true;
          }).map((s, i) => (
            <InfoCard key={s.title} $delay={`${i * 0.1}s`}>
              <CardIcon $bg={s.bg}>{s.icon}</CardIcon>
              <CardTitle>{s.title}</CardTitle>
              <CardText>{s.text}</CardText>
              <div>{s.tags.map(t => <CardTag key={t}>{t}</CardTag>)}</div>
            </InfoCard>
          ))}
        </CardGrid>
      )}
    </Section>
  );

  // ── Recipes ──
  const renderRecipes = () => (
    <Section>
      <SectionEyebrow>Satvik Kitchen</SectionEyebrow>
      <SectionHeading>Nourishing <em>Vedic Recipes</em></SectionHeading>
      <SectionSubtext>100+ handcrafted Indian recipes for every stage of your wellness journey — from morning sickness to lactation support.</SectionSubtext>
      <TabRow>
        {["All", "Prenatal", "Postnatal", "Fertility", "PCOS", "Diabetes"].map(t => (
          <Tab key={t} $active={activeTab === t} onClick={() => setActiveTab(t)}>{t}</Tab>
        ))}
      </TabRow>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 24 }}>
        {RECIPES.filter(r => activeTab === "All" || r.category === activeTab).map((r, i) => (
          <RecipeCard key={r.title} $delay={`${i * 0.08}s`}>
            <RecipeImage $bg={r.bg}>
              <span style={{ fontSize: 56 }}>{r.emoji}</span>
              <RecipeBadge>{r.category}</RecipeBadge>
            </RecipeImage>
            <RecipeBody>
              <RecipeTitle>{r.title}</RecipeTitle>
              <RecipeMeta><span>⏱ {r.time}</span><span>📊 {r.difficulty}</span></RecipeMeta>
              <BtnSaffron style={{ width: "100%", padding: "10px", fontSize: 13, borderRadius: 12 }}>View Recipe</BtnSaffron>
            </RecipeBody>
          </RecipeCard>
        ))}
      </div>
    </Section>
  );

  // ── Consult ──
  const renderConsult = () => (
    <Section>
      <SectionEyebrow>Expert Support</SectionEyebrow>
      <SectionHeading>Consult a <em>Prenatal Nutritionist</em></SectionHeading>
      <SectionSubtext>Our certified experts specialise in pregnancy, postnatal recovery, and fertility nutrition. Choose how you'd like to connect.</SectionSubtext>
      <ConsultBanner>
        <ConsultHeading>Book Your Consultation</ConsultHeading>
        <ConsultText>Get a 60-minute personalised session with a certified nutritionist — available via video call or WhatsApp.</ConsultText>
        <ConsultBtnRow>
          <WABtn href="https://wa.me/919999999999?text=Hi%2C+I%27d+like+to+book+a+nutrition+consultation" target="_blank" rel="noopener noreferrer">
            <span>📱</span> WhatsApp Consultation
          </WABtn>
          <BtnPrimary style={{ background: "#F9F1E4", color: "#7A3300" }} onClick={() => setModal("booking")}>
            📅 Book Video Session
          </BtnPrimary>
        </ConsultBtnRow>
      </ConsultBanner>
      <div style={{ marginTop: 40 }}>
        <CardGrid>
          {[
            { icon: "👩‍⚕️", title: "Prenatal Nutrition", text: "Trimester-by-trimester guidance, supplement support, and weight gain tracking.", bg: "#F5E8CC" },
            { icon: "🤱", title: "Postnatal & Lactation", text: "Milk supply, recovery meals, C-section diet, and postpartum wellness planning.", bg: "#F2DED4" },
            { icon: "🌸", title: "Fertility & PCOS", text: "Hormone-balancing protocols, anti-inflammatory diets, and cycle nutrition.", bg: "#EDE3D5" },
          ].map((s, i) => (
            <InfoCard key={s.title} $delay={`${i * 0.1}s`}>
              <CardIcon $bg={s.bg}>{s.icon}</CardIcon>
              <CardTitle>{s.title}</CardTitle>
              <CardText>{s.text}</CardText>
              <BtnSaffron style={{ padding: "10px 20px", fontSize: 13 }} onClick={() => setModal("booking")}>Book Session</BtnSaffron>
            </InfoCard>
          ))}
        </CardGrid>
      </div>
    </Section>
  );

  // ── Admin Panel ──
  const renderAdmin = () => {
    if (!adminUnlocked) {
      return (
        <Section style={{ maxWidth: 440, padding: "80px 24px" }}>
          <FormCard style={{ textAlign: "center" }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🔒</div>
            <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontWeight: 500, color: "#2E1A0E", margin: "0 0 8px" }}>Admin Panel</p>
            <p style={{ color: "#9C7E66", fontSize: 14, marginBottom: 24 }}>Enter your PIN to access the admin dashboard.</p>
            <FormInput type="password" placeholder="Enter PIN" value={adminPin}
              onChange={e => setAdminPin(e.target.value)}
              onKeyDown={e => { if (e.key === "Enter" && adminPin === ADMIN_PIN) setAdminUnlocked(true); }}
              style={{ marginBottom: 16 }} />
            <BtnSaffron style={{ width: "100%" }} onClick={() => { if (adminPin === ADMIN_PIN) setAdminUnlocked(true); else alert("Incorrect PIN"); }}>
              Unlock Admin →
            </BtnSaffron>
            <p style={{ fontSize: 12, color: "#9C7E66", marginTop: 12 }}>Demo PIN: 1234</p>
          </FormCard>
        </Section>
      );
    }

    const MOCK_USERS = [
      { id: 1, name: "Priya Sharma",   stage: "Pregnant",      plan: "Prenatal",  joined: "Jun 1",  status: "active"   },
      { id: 2, name: "Ananya Reddy",   stage: "Postpartum",    plan: "Postnatal", joined: "Jun 3",  status: "active"   },
      { id: 3, name: "Kavita Singh",   stage: "TTC",           plan: "Fertility", joined: "Jun 8",  status: "pending"  },
      { id: 4, name: "Deepa Menon",    stage: "PCOS",          plan: "PCOS",      joined: "Jun 10", status: "active"   },
      { id: 5, name: "Sunita Patel",   stage: "Weight Loss",   plan: "WL Plan",   joined: "Jun 12", status: "inactive" },
    ];

    const MOCK_FOODS = [
      { name: "Brown Rice",     cal: 216, protein: 5,  carbs: 45, fat: 2  },
      { name: "Moong Dal",      cal: 147, protein: 14, carbs: 25, fat: 1  },
      { name: "Palak Paneer",   cal: 240, protein: 11, carbs: 8,  fat: 18 },
      { name: "Roti (1 piece)", cal: 104, protein: 3,  carbs: 20, fat: 1  },
    ];

    return (
      <AdminLayout>
        <AdminSidebar>
          {[
            { key: "analytics", label: "📊 Analytics" },
            { key: "users",     label: "👥 Users" },
            { key: "foods",     label: "🥗 Food Database" },
            { key: "templates", label: "📋 Diet Templates" },
          ].map(item => (
            <AdminSidebarItem key={item.key} $active={adminSub === item.key} onClick={() => setAdminSub(item.key)}>
              {item.label}
            </AdminSidebarItem>
          ))}
        </AdminSidebar>

        <AdminContent>
          {adminSub === "analytics" && (
            <>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontWeight: 500, color: "#2E1A0E", margin: "0 0 20px" }}>Analytics Dashboard</p>
              <AnalyticsGrid>
                {[
                  { label: "Total Users",     val: "5,284",  delta: "+12% this month",  bg: "#F5E8CC" },
                  { label: "Active Plans",    val: "3,891",  delta: "+8% this week",     bg: "#F2DED4" },
                  { label: "Consultations",   val: "428",    delta: "+22% this month",   bg: "#EDE3D5" },
                  { label: "PDF Downloads",   val: "1,240",  delta: "+35% this month",   bg: "#F5E8CC" },
                  { label: "Chat Sessions",   val: "12,580", delta: "avg 4.2/user",       bg: "#F2DED4" },
                  { label: "Plan Completions",val: "71%",    delta: "7-day adherence",    bg: "#EDE3D5" },
                ].map((c, i) => (
                  <AnalyticsCard key={c.label} $delay={`${i * 0.08}s`}>
                    <StatLabel>{c.label}</StatLabel>
                    <StatValue $color="#C05C00" style={{ fontSize: 30, marginBottom: 6 }}>{c.val}</StatValue>
                    <p style={{ margin: 0, fontSize: 12, color: "#16a34a", fontWeight: 500 }}>↑ {c.delta}</p>
                  </AnalyticsCard>
                ))}
              </AnalyticsGrid>

              <div style={{ background: "#fff", borderRadius: 16, padding: 24, border: "1px solid rgba(192,92,0,0.1)" }}>
                <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 500, color: "#2E1A0E", margin: "0 0 16px" }}>Popular Conditions</p>
                {[["PCOS",  72], ["Pregnancy",  68], ["Weight Loss",  55], ["Fertility",  48], ["Thyroid",  32]].map(([name, pct]) => (
                  <div key={name} style={{ marginBottom: 14 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                      <span style={{ fontSize: 13, color: "#4A2E1A" }}>{name}</span>
                      <span style={{ fontSize: 12, color: "#9C7E66" }}>{pct}%</span>
                    </div>
                    <div style={{ height: 8, background: "#F2E8D8", borderRadius: 40, overflow: "hidden" }}>
                      <div style={{ height: "100%", width: `${pct}%`, background: "linear-gradient(90deg,#D4973A,#C05C00)", borderRadius: 40, transition: "width 0.8s ease" }} />
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {adminSub === "users" && (
            <>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20, flexWrap: "wrap", gap: 12 }}>
                <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontWeight: 500, color: "#2E1A0E", margin: 0 }}>User Management</p>
                <BtnSaffron style={{ fontSize: 13, padding: "10px 22px" }}>+ Add User</BtnSaffron>
              </div>
              <AdminTable>
                <thead>
                  <tr><th>Name</th><th>Stage</th><th>Current Plan</th><th>Joined</th><th>Status</th><th>Actions</th></tr>
                </thead>
                <tbody>
                  {MOCK_USERS.map(u => (
                    <tr key={u.id}>
                      <td style={{ fontWeight: 500 }}>{u.name}</td>
                      <td>{u.stage}</td>
                      <td>{u.plan}</td>
                      <td style={{ color: "#9C7E66" }}>{u.joined}</td>
                      <td><Badge $variant={u.status === "active" ? "success" : u.status === "pending" ? "warning" : "danger"}>{u.status}</Badge></td>
                      <td><div style={{ display: "flex", gap: 6 }}><BtnSmall>View</BtnSmall><BtnSmall $variant="danger">Remove</BtnSmall></div></td>
                    </tr>
                  ))}
                </tbody>
              </AdminTable>
            </>
          )}

          {adminSub === "foods" && (
            <>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20, flexWrap: "wrap", gap: 12 }}>
                <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontWeight: 500, color: "#2E1A0E", margin: 0 }}>Food Database</p>
                <BtnSaffron style={{ fontSize: 13, padding: "10px 22px" }}>+ Add Food</BtnSaffron>
              </div>
              <AdminTable>
                <thead>
                  <tr><th>Food Name</th><th>Calories (100g)</th><th>Protein (g)</th><th>Carbs (g)</th><th>Fat (g)</th><th>Actions</th></tr>
                </thead>
                <tbody>
                  {MOCK_FOODS.map((f, i) => (
                    <tr key={i}>
                      <td style={{ fontWeight: 500 }}>{f.name}</td>
                      <td>{f.cal}</td><td>{f.protein}</td><td>{f.carbs}</td><td>{f.fat}</td>
                      <td><div style={{ display: "flex", gap: 6 }}><BtnSmall>Edit</BtnSmall><BtnSmall $variant="danger">Delete</BtnSmall></div></td>
                    </tr>
                  ))}
                </tbody>
              </AdminTable>
            </>
          )}

          {adminSub === "templates" && (
            <>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontWeight: 500, color: "#2E1A0E", margin: "0 0 20px" }}>Diet Templates</p>
              <CardGrid>
                {CONDITIONS.map((c, i) => (
                  <InfoCard key={c.id} $delay={`${i * 0.06}s`}>
                    <CardIcon $bg="#F5E8CC">{c.icon}</CardIcon>
                    <CardTitle>{c.name}</CardTitle>
                    <CardText>{c.tag}</CardText>
                    <div style={{ display: "flex", gap: 8 }}>
                      <BtnSmall>Edit Template</BtnSmall>
                      <BtnSmall $variant="success">Active</BtnSmall>
                    </div>
                  </InfoCard>
                ))}
              </CardGrid>
            </>
          )}
        </AdminContent>
      </AdminLayout>
    );
  };

  // ── Modals ──
  const renderModals = () => {
    if (!modal) return null;
    return (
      <ModalOverlay onClick={e => { if (e.target === e.currentTarget) setModal(null); }}>
        <ModalBox>
          <ModalClose onClick={() => setModal(null)}>✕</ModalClose>

          {modal === "pdf" && (
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: 52, marginBottom: 16 }}>📄</div>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontWeight: 500, color: "#2E1A0E", margin: "0 0 8px" }}>Download Your Free Plan</p>
              <p style={{ color: "#9C7E66", fontSize: 14, marginBottom: 24 }}>Enter your details and we'll email you a beautiful 7-day personalised meal plan PDF.</p>
              <FormGroup style={{ marginBottom: 16 }}><FormLabel>Your Name</FormLabel><FormInput placeholder="Priya Sharma" /></FormGroup>
              <FormGroup style={{ marginBottom: 16 }}><FormLabel>Email Address</FormLabel><FormInput type="email" placeholder="priya@example.com" /></FormGroup>
              <FormGroup style={{ marginBottom: 24 }}><FormLabel>WhatsApp Number (optional)</FormLabel><FormInput placeholder="+91 98765 43210" /></FormGroup>
              <BtnSaffron style={{ width: "100%" }} onClick={() => { alert("🌸 Your plan will be sent to your email shortly!"); setModal(null); }}>
                📩 Send Me My Free Plan
              </BtnSaffron>
              <p style={{ fontSize: 11, color: "#9C7E66", marginTop: 12 }}>We respect your privacy. No spam, ever.</p>
            </div>
          )}

          {modal === "booking" && (
            <div>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontWeight: 500, color: "#2E1A0E", margin: "0 0 6px" }}>📅 Book a Consultation</p>
              <p style={{ color: "#9C7E66", fontSize: 14, marginBottom: 24 }}>60-minute personalised session with a certified nutritionist.</p>
              <FormGrid $cols={2}>
                <FormGroup><FormLabel>Your Name</FormLabel><FormInput placeholder="Priya Sharma" /></FormGroup>
                <FormGroup><FormLabel>Phone / WhatsApp</FormLabel><FormInput placeholder="+91 98765 43210" /></FormGroup>
              </FormGrid>
              <FormGroup style={{ marginTop: 16, marginBottom: 16 }}>
                <FormLabel>Session Type</FormLabel>
                <FormSelect>
                  <option>Video Call (Zoom / Meet)</option>
                  <option>WhatsApp Consultation</option>
                  <option>In-Person (Mumbai only)</option>
                </FormSelect>
              </FormGroup>
              <FormGroup style={{ marginBottom: 16 }}>
                <FormLabel>Specialisation Needed</FormLabel>
                <FormSelect><option>Prenatal Nutrition</option><option>Postnatal & Lactation</option><option>Fertility & PCOS</option><option>Weight Management</option><option>Thyroid / Diabetes</option></FormSelect>
              </FormGroup>
              <FormGroup style={{ marginBottom: 24 }}>
                <FormLabel>Preferred Date & Time</FormLabel>
                <FormInput type="datetime-local" />
              </FormGroup>
              <BtnSaffron style={{ width: "100%" }} onClick={() => { alert("🌸 Booking confirmed! We'll reach out within 24 hours."); setModal(null); }}>
                Confirm Booking
              </BtnSaffron>
            </div>
          )}

          {modal === "premium" && (
            <div style={{ textAlign: "center" }}>
              <PremiumBadge style={{ justifyContent: "center", margin: "0 auto 16px" }}>✨ Premium</PremiumBadge>
              <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, fontWeight: 500, color: "#2E1A0E", margin: "0 0 8px" }}>Upgrade to Premium</p>
              <p style={{ color: "#9C7E66", fontSize: 14, marginBottom: 28 }}>Unlock unlimited AI plans, PDF downloads, priority consultation booking, and more.</p>
              {[["Weekly AI-generated meal plans", "✅"], ["Unlimited PDF downloads", "✅"], ["Priority consultation booking", "✅"], ["Advanced progress analytics", "✅"], ["Personalised supplement guide", "✅"]].map(([f, v]) => (
                <div key={f} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid rgba(192,92,0,0.08)" }}>
                  <span style={{ fontSize: 14 }}>{f}</span><span>{v}</span>
                </div>
              ))}
              <div style={{ background: "#F5E8CC", borderRadius: 16, padding: "18px 20px", margin: "24px 0", textAlign: "center" }}>
                <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 32, fontWeight: 500, color: "#C05C00", margin: "0 0 4px" }}>₹999<span style={{ fontSize: 16, fontWeight: 400 }}> / month</span></p>
                <p style={{ fontSize: 12, color: "#9C7E66", margin: 0 }}>Cancel anytime</p>
              </div>
              <BtnSaffron style={{ width: "100%" }} onClick={() => { alert("🌸 Redirecting to payment…"); setModal(null); }}>Start Premium Today</BtnSaffron>
            </div>
          )}
        </ModalBox>
      </ModalOverlay>
    );
  };

  // ─── App Shell ────────────────────────────────────────────────────────────────
  const navItems = [
    { key: "home",      label: "Home" },
    { key: "chat",      label: "AI Guide 🌸" },
    { key: "profile",   label: "My Profile" },
    { key: "plans",     label: "AI Plans" },
    { key: "tracker",   label: "Progress" },
    { key: "yoga",      label: "Yoga" },
    { key: "nutrition", label: "Nutrition" },
    { key: "recipes",   label: "Recipes" },
    { key: "consult",   label: "Consult" },
    ...(showDashboard ? [{ key: "dashboard", label: "My Plan ✨" }] : []),
    { key: "admin",     label: "Admin" },
  ];

  const mobileNavItems = [
    { key: "home",      icon: "🏠", label: "Home"    },
    { key: "chat",      icon: "🌸", label: "Priya"   },
    { key: "plans",     icon: "🤖", label: "AI Plans" },
    { key: "tracker",   icon: "📊", label: "Progress" },
    { key: "yoga",      icon: "🧘", label: "Yoga"    },
  ];

  return (
    <PageWrapper className="diet-planner">
      <DietGlobalStyle />

      {/* ── Sticky Nav ── */}
      <nav style={{
        position: "sticky", top: 0, zIndex: 100,
        background: "rgba(249,241,228,0.96)",
        backdropFilter: "blur(12px)",
        borderBottom: "1px solid rgba(192,92,0,0.12)",
        padding: "0 24px",
      }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between", height: 64 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontSize: 22 }}>🪷</span>
            <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 500, color: "#2E1A0E" }}>Yoga Shastra</span>
            <span style={{ fontSize: 12, color: "#9C7E66", paddingLeft: 8, borderLeft: "1px solid #C8856A" }}>Nutrition</span>
          </div>
          <div style={{ display: "flex", gap: 2, overflowX: "auto", maxWidth: "60vw" }}>
            {navItems.map(n => (
              <button key={n.key} onClick={() => setActiveSection(n.key)} style={{
                padding: "8px 12px", fontSize: 12.5,
                fontFamily: "'DM Sans', sans-serif",
                fontWeight: n.key === activeSection ? 500 : 400,
                background: n.key === activeSection ? "#C05C00" : "transparent",
                color: n.key === activeSection ? "#F9F1E4" : "#5C3A1E",
                border: "none", borderRadius: 40, cursor: "pointer", whiteSpace: "nowrap",
                transition: "all 0.2s ease",
              }}>{n.label}</button>
            ))}
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <BtnOutline onClick={() => setModal("premium")} style={{ fontSize: 12, padding: "8px 16px" }}>✨ Premium</BtnOutline>
            <BtnSaffron onClick={() => setActiveSection("consult")} style={{ fontSize: 13, padding: "9px 18px" }}>Book Consult</BtnSaffron>
          </div>
        </div>
      </nav>

      {/* ── Content ── */}
      {activeSection === "home"      && renderHome()}
      {activeSection === "chat"      && renderChat()}
      {activeSection === "profile"   && renderProfile()}
      {activeSection === "plans"     && renderPlans()}
      {activeSection === "tracker"   && renderTracker()}
      {activeSection === "yoga"      && renderYoga()}
      {activeSection === "dashboard" && renderDashboard()}
      {activeSection === "nutrition" && renderNutrition()}
      {activeSection === "recipes"   && renderRecipes()}
      {activeSection === "consult"   && renderConsult()}
      {activeSection === "admin"     && renderAdmin()}

      <MobileBottomPad />

      {/* ── Mobile Bottom Nav ── */}
      <BottomNav>
        {mobileNavItems.map(n => (
          <BottomNavItem key={n.key} $active={activeSection === n.key} onClick={() => setActiveSection(n.key)}>
            <span className="icon">{n.icon}</span>
            <span className="label">{n.label}</span>
          </BottomNavItem>
        ))}
      </BottomNav>

      {/* ── Footer ── */}
      <footer style={{ background: "#7A3300", padding: "40px 24px", textAlign: "center" }}>
        <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, color: "#F9F1E4", margin: "0 0 8px" }}>🪷 Yoga Shastra</p>
        <p style={{ fontSize: 13, color: "rgba(249,241,228,0.6)", margin: 0 }}>A complete pregnancy &amp; women's wellness ecosystem · Nourish. Heal. Thrive.</p>
        <OmDivider style={{ marginTop: 20 }}>ॐ</OmDivider>
      </footer>

      {/* ── Modals ── */}
      {renderModals()}
    </PageWrapper>
  );
}